<script setup lang="ts">
import merge from 'lodash-es/merge';
import ArticleHeadlineCoversService from '../../_runtime/services/ArticleHeadlineCoversService';

defineOptions({
    name: 'ModuleArticlesSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    mode: 'single',
    isPhotoView: false,
    headlineCoverId: null
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

async function fetchHeadlineCover(id: number): Promise<any>
{
    const response = await ArticleHeadlineCoversService.fetchAutocompleteModel(id);

    return response || null;
}

async function searchHeadlineCover(query: string, limit: number): Promise<any[]>
{
    return await ArticleHeadlineCoversService.getAutocompleteList(query, limit);
}

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

onBeforeMount((): void =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Tryb wyświetlania]]]')" :invalid-feedback="form.$errors.first('settings.mode')" :state="form.$errors.state('settings.mode')">
        <IdeoFormRadio v-model="form.settings.mode" name="articles" value="single">
            {{ $t('[[[Pojedynczy artykuł (strona opisowa)]]]') }}
        </IdeoFormRadio>
        <IdeoFormRadio v-model="form.settings.mode" name="articles" value="list">
            {{ $t('[[[Lista artykułów]]]') }}
        </IdeoFormRadio>
    </IdeoFormGroup>
    <IdeoFormGroup :invalid-feedback="form.$errors.first('settings.publishByUser')" :state="form.$errors.state('settings.publishByUser')">
        <IdeoFormCheckbox v-model="form.settings.publishByUser">
            {{ $t('[[[Publikacja wpisów przez użytkownika]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>
    <IdeoFormGroup v-if="form.settings.publishByUser" :invalid-feedback="form.$errors.first('settings.autoPublish')" :state="form.$errors.state('settings.autoPublish')">
        <IdeoFormCheckbox v-model="form.settings.autoPublish">
            {{ $t('[[[Automatyczna publikacja wpisów]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>
</template>
